import React from 'react';
import CustomPageBlock, { PageBlockProps } from './page-block';
import { VacancyModel } from 'src/types';
import { WORK_SEARCH } from 'src/constants/routes';
import GeneralVacancies from '../general/vacancies/vacancies';
import css from './custom-page.module.scss';

export default function CustomPageVacancies({
  items,
  title,
  description,
  type
}: Readonly<PageBlockProps<VacancyModel>>) {
  return (
    <CustomPageBlock title={title} description={description} type={type} path={WORK_SEARCH.path}>
      <GeneralVacancies items={items} title={<p className={css.placeholder}></p>} />
    </CustomPageBlock>
  );
}
